import { useState, useEffect, useCallback } from 'react';
import { useAuth } from '../../context/AuthContext';
import { apiRequest } from '../../services/api';
import { downloadExcel } from '../../utils/exportUtils';
import DatePicker from '../../components/DatePicker';

function pad(n) { return String(n).padStart(2, '0'); }
function bugun() { var d = new Date(); return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear(); }
function ayBasi() {
  var d = new Date(); d.setDate(1);
  return pad(d.getDate()) + '.' + pad(d.getMonth() + 1) + '.' + d.getFullYear();
}
function dpToISO(dp) { var [g, a, y] = dp.split('.'); return y + '-' + a + '-' + g; }

export default function KampAmiriSayfa() {
  var { personel, logoutUser } = useAuth();

  var [data, setData] = useState(null);
  var [yukleniyor, setYukleniyor] = useState(true);
  var [hata, setHata] = useState('');
  var [rezAcik, setRezAcik] = useState(true);
  var [bosAcik, setBosAcik] = useState(true);
  var [puantajAcik, setPuantajAcik] = useState(true);

  var [puantajBas, setPuantajBas] = useState(ayBasi());
  var [puantajBit, setPuantajBit] = useState(bugun());
  var [puantajMod, setPuantajMod] = useState('oda'); // 'oda' | 'kisi'
  var [puantajData, setPuantajData] = useState(null);
  var [puantajYukleniyor, setPuantajYukleniyor] = useState(false);
  var [puantajHata, setPuantajHata] = useState('');

  const yukle = useCallback(async function() {
    setYukleniyor(true); setHata('');
    try {
      var d = await apiRequest('kampamiri/gorunum');
      setData(d);
    } catch { setHata('Veriler yüklenemedi.'); }
    setYukleniyor(false);
  }, []);

  useEffect(function() { yukle(); }, [yukle]);

  async function puantajGetir() {
    setPuantajYukleniyor(true); setPuantajHata(''); setPuantajData(null);
    try {
      var bas = dpToISO(puantajBas);
      var bit = dpToISO(puantajBit);
      var d = await apiRequest('kampamiri/puantaj?bas=' + bas + '&bit=' + bit);
      setPuantajData(d || []);
    } catch { setPuantajHata('Puantaj verisi alınamadı.'); }
    setPuantajYukleniyor(false);
  }

  function puantajExcel() {
    if (!puantajData || puantajData.length === 0) return;
    var donem = puantajBas + ' — ' + puantajBit;

    if (puantajMod === 'oda') {
      // Oda bazlı: her rezervasyon bir satır
      downloadExcel(
        'puantaj-oda-' + puantajBas + '-' + puantajBit,
        'Konaklama Puantajı',
        ['Oda No', 'Misafirler', 'Giriş', 'Çıkış', 'Dönem Giriş', 'Dönem Çıkış', 'Gece', 'Durum'],
        puantajData.map(function(r) {
          return [
            r.odaNo,
            (r.misafirler || []).join(', ') || '—',
            r.girisTarihi,
            r.cikisTarihi,
            r.donemGiris,
            r.donemCikis,
            r.geceSayisi,
            r.durum,
          ];
        })
      );
    } else {
      // Kişi bazlı: her misafir için ayrı satır
      var satirlar = [];
      puantajData.forEach(function(r) {
        var misafirler = (r.misafirler && r.misafirler.length > 0) ? r.misafirler : ['—'];
        misafirler.forEach(function(ad) {
          satirlar.push([
            ad,
            r.odaNo,
            r.girisTarihi,
            r.cikisTarihi,
            r.donemGiris,
            r.donemCikis,
            r.geceSayisi,
            r.durum,
          ]);
        });
      });
      downloadExcel(
        'puantaj-kisi-' + puantajBas + '-' + puantajBit,
        'Konaklama Puantajı',
        ['Ad Soyad', 'Oda No', 'Giriş', 'Çıkış', 'Dönem Giriş', 'Dönem Çıkış', 'Gece', 'Durum'],
        satirlar
      );
    }
  }

  function handleCikis() {
    logoutUser();
    window.location.href = '/login';
  }

  var INP = 'w-full border-2 border-gray-100 rounded-2xl px-4 py-3 text-sm font-bold text-gray-700 focus:outline-none focus:border-indigo-400 bg-white';

  return (
    <div className="min-h-screen bg-gray-50 font-sans">
      {/* Header */}
      <div className="bg-white border-b border-gray-100 shadow-sm px-6 py-4 flex items-center justify-between">
        <div className="flex items-center gap-3">
          <div className="w-10 h-10 bg-gradient-to-br from-violet-600 to-indigo-700 rounded-xl flex items-center justify-center text-white text-lg shadow-lg">🏕️</div>
          <div>
            <h1 className="text-sm font-black text-gray-900 uppercase tracking-tight leading-none">Firma Yetkilisi Paneli</h1>
            <p className="text-[10px] font-bold text-gray-400 uppercase tracking-widest mt-0.5">{personel?.adSoyad || ''}</p>
          </div>
        </div>
        <div className="flex items-center gap-3">
          <button onClick={yukle} className="px-4 py-2 bg-indigo-50 text-indigo-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-indigo-100 transition-all">Yenile</button>
          <button onClick={handleCikis} className="px-4 py-2 bg-gray-100 text-gray-600 rounded-xl text-[10px] font-black uppercase tracking-widest hover:bg-gray-200 transition-all">Çıkış</button>
        </div>
      </div>

      <div className="max-w-3xl mx-auto px-4 py-8 space-y-6">
        {yukleniyor && (
          <div className="py-20 text-center">
            <div className="w-12 h-12 border-4 border-indigo-200 border-t-indigo-600 rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Yükleniyor...</p>
          </div>
        )}

        {hata && (
          <div className="bg-rose-50 border-2 border-rose-100 rounded-2xl px-6 py-5 text-center">
            <p className="text-[10px] font-black text-rose-600 uppercase tracking-widest">⚠️ {hata}</p>
          </div>
        )}

        {!yukleniyor && data && (
          <>
            {/* ── Konaklama Puantajı ── */}
            <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
              <button
                onClick={() => setPuantajAcik(p => !p)}
                className="w-full px-6 py-5 flex items-center justify-between bg-gradient-to-r from-amber-50 to-orange-50 hover:from-amber-100 hover:to-orange-100 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">📊</span>
                  <div className="text-left">
                    <p className="text-sm font-black text-amber-900 uppercase tracking-tight">Konaklama Puantajı</p>
                    <p className="text-[9px] font-bold text-amber-400 uppercase tracking-widest">Excel / Dönemsel Rapor</p>
                  </div>
                </div>
                <span className="text-amber-400 font-black text-lg">{puantajAcik ? '▲' : '▼'}</span>
              </button>

              {puantajAcik && (
                <div className="p-6 space-y-5">
                  {/* Tarih ve mod seçimi */}
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-[9px] font-black text-gray-400 uppercase tracking-widest block mb-1.5">Başlangıç</label>
                      <DatePicker value={puantajBas} onChange={setPuantajBas} />
                    </div>
                    <div>
                      <label className="text-[9px] font-black text-gray-400 uppercase tracking-widest block mb-1.5">Bitiş</label>
                      <DatePicker value={puantajBit} onChange={setPuantajBit} />
                    </div>
                  </div>

                  <div className="flex gap-3">
                    <button onClick={() => setPuantajMod('oda')}
                      className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${puantajMod === 'oda' ? 'bg-amber-500 text-white shadow-lg' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>
                      🏠 Oda Bazlı
                    </button>
                    <button onClick={() => setPuantajMod('kisi')}
                      className={`flex-1 py-2.5 rounded-xl text-[10px] font-black uppercase tracking-widest transition-all ${puantajMod === 'kisi' ? 'bg-amber-500 text-white shadow-lg' : 'bg-gray-100 text-gray-500 hover:bg-gray-200'}`}>
                      👤 Kişi Bazlı
                    </button>
                  </div>

                  <button onClick={puantajGetir} disabled={puantajYukleniyor}
                    className="w-full py-3 bg-gray-900 hover:bg-black text-white rounded-xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 disabled:opacity-50">
                    {puantajYukleniyor ? 'Yükleniyor...' : 'Puantajı Getir'}
                  </button>

                  {puantajHata && <p className="text-[10px] font-black text-rose-600 text-center uppercase tracking-widest">⚠️ {puantajHata}</p>}

                  {puantajData && (
                    <div className="space-y-4">
                      <div className="flex items-center justify-between">
                        <p className="text-[10px] font-black text-gray-500 uppercase tracking-widest">
                          {puantajBas} — {puantajBit} · {puantajData.length} kayıt
                        </p>
                        {puantajData.length > 0 && (
                          <button onClick={puantajExcel}
                            className="flex items-center gap-2 px-4 py-2 bg-emerald-500 hover:bg-emerald-600 text-white rounded-xl text-[10px] font-black uppercase tracking-widest transition-all active:scale-95 shadow-lg shadow-emerald-100">
                            <span>📥</span> Excel İndir
                          </button>
                        )}
                      </div>

                      {puantajData.length === 0 ? (
                        <div className="py-10 text-center bg-gray-50 rounded-2xl border-2 border-dashed border-gray-100">
                          <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Bu dönemde kayıt bulunamadı</p>
                        </div>
                      ) : (
                        <div className="space-y-3">
                          {puantajData.map(function(r, i) {
                            var toplamGece = r.geceSayisi;
                            return (
                              <div key={i} className="bg-gray-50 rounded-2xl p-4 border border-gray-100">
                                <div className="flex items-start justify-between gap-3 mb-3">
                                  <div className="flex items-center gap-3">
                                    <div className="w-10 h-10 bg-indigo-100 rounded-xl flex items-center justify-center flex-shrink-0">
                                      <span className="text-[10px] font-black text-indigo-700">{r.odaNo}</span>
                                    </div>
                                    <div>
                                      <p className="text-[9px] font-black text-indigo-600 uppercase tracking-widest">Oda {r.odaNo}</p>
                                      <div className="flex flex-wrap gap-1 mt-1">
                                        {(r.misafirler && r.misafirler.length > 0)
                                          ? r.misafirler.map(function(ad, j) { return <span key={j} className="text-xs font-bold text-gray-800">{ad}{j < r.misafirler.length - 1 ? ', ' : ''}</span>; })
                                          : <span className="text-xs font-bold text-gray-400 italic">Misafir bilgisi yok</span>}
                                      </div>
                                    </div>
                                  </div>
                                  <div className="text-right flex-shrink-0">
                                    <p className="text-lg font-black text-indigo-700 leading-none">{toplamGece}</p>
                                    <p className="text-[9px] font-bold text-gray-400 uppercase">gece</p>
                                  </div>
                                </div>
                                <div className="grid grid-cols-2 gap-2 text-[9px] font-bold text-gray-500 uppercase tracking-widest">
                                  <span>Giriş: <span className="text-gray-700">{r.girisTarihi}</span></span>
                                  <span>Çıkış: <span className="text-gray-700">{r.cikisTarihi}</span></span>
                                  {(r.donemGiris !== r.girisTarihi || r.donemCikis !== r.cikisTarihi) && (
                                    <>
                                      <span className="text-amber-600">Dönem başı: <span className="font-black">{r.donemGiris}</span></span>
                                      <span className="text-amber-600">Dönem sonu: <span className="font-black">{r.donemCikis}</span></span>
                                    </>
                                  )}
                                </div>
                                <div className="mt-2">
                                  <span className={`text-[9px] font-black px-2 py-1 rounded-lg uppercase tracking-widest ${r.durum === 'C-OUT Yapıldı' ? 'bg-gray-100 text-gray-500' : 'bg-emerald-50 text-emerald-600'}`}>
                                    {r.durum}
                                  </span>
                                </div>
                              </div>
                            );
                          })}

                          {/* Dönem özeti */}
                          <div className="bg-amber-50 border border-amber-100 rounded-2xl p-4 flex items-center justify-between">
                            <p className="text-[10px] font-black text-amber-700 uppercase tracking-widest">Toplam Konaklama</p>
                            <p className="text-xl font-black text-amber-800">
                              {puantajData.reduce(function(s,r) { return s + r.geceSayisi; }, 0)} <span className="text-sm">gece</span>
                            </p>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                </div>
              )}
            </div>

            {/* ── Firmamıza Ait Odalar ── */}
            <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
              <button
                onClick={() => setRezAcik(p => !p)}
                className="w-full px-6 py-5 flex items-center justify-between bg-gradient-to-r from-indigo-50 to-violet-50 hover:from-indigo-100 hover:to-violet-100 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">🏠</span>
                  <div className="text-left">
                    <p className="text-sm font-black text-indigo-900 uppercase tracking-tight">Şu An Dolu Odalar</p>
                    <p className="text-[9px] font-bold text-indigo-400 uppercase tracking-widest">{data.firmaRezervasyonlar?.length || 0} rezervasyon</p>
                  </div>
                </div>
                <span className="text-indigo-400 font-black text-lg">{rezAcik ? '▲' : '▼'}</span>
              </button>

              {rezAcik && (
                <div className="divide-y divide-gray-50">
                  {(!data.firmaRezervasyonlar || data.firmaRezervasyonlar.length === 0) ? (
                    <div className="py-12 text-center">
                      <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Aktif rezervasyon bulunamadı</p>
                    </div>
                  ) : data.firmaRezervasyonlar.map(function(r, i) {
                    return (
                      <div key={i} className="px-6 py-4 flex items-start gap-4 hover:bg-gray-50 transition-colors">
                        <div className="w-12 h-12 bg-indigo-50 rounded-xl flex items-center justify-center flex-shrink-0">
                          <span className="text-[10px] font-black text-indigo-600 uppercase">{r.odaNo}</span>
                        </div>
                        <div className="flex-1 min-w-0">
                          <div className="flex items-center gap-2 mb-1.5">
                            <span className="text-[9px] font-black px-2 py-1 rounded-lg uppercase tracking-widest bg-indigo-50 text-indigo-600">ODA {r.odaNo}</span>
                            <span className={`text-[9px] font-black px-2 py-1 rounded-lg uppercase tracking-widest ${r.durum === 'C-IN Yapıldı' ? 'bg-emerald-50 text-emerald-600' : 'bg-amber-50 text-amber-600'}`}>
                              {r.durum}
                            </span>
                          </div>
                          {r.misafirler && r.misafirler.length > 0 ? (
                            <div className="space-y-1">
                              {r.misafirler.map(function(ad, j) { return <p key={j} className="text-sm font-bold text-gray-800 leading-none">{ad}</p>; })}
                            </div>
                          ) : (
                            <p className="text-[10px] font-bold text-gray-400 italic">Misafir bilgisi yok</p>
                          )}
                          <div className="flex items-center gap-3 mt-2">
                            {r.girisTarihi && <span className="text-[9px] font-bold text-gray-400">Giriş: {new Date(r.girisTarihi).toLocaleDateString('tr-TR')}</span>}
                            {r.cikisTarihi && <span className="text-[9px] font-bold text-gray-400">Çıkış: {new Date(r.cikisTarihi).toLocaleDateString('tr-TR')}</span>}
                          </div>
                        </div>
                      </div>
                    );
                  })}
                </div>
              )}
            </div>

            {/* ── Boş Odalar ── */}
            <div className="bg-white rounded-[2rem] border border-gray-100 shadow-sm overflow-hidden">
              <button
                onClick={() => setBosAcik(p => !p)}
                className="w-full px-6 py-5 flex items-center justify-between bg-gradient-to-r from-emerald-50 to-teal-50 hover:from-emerald-100 hover:to-teal-100 transition-colors"
              >
                <div className="flex items-center gap-3">
                  <span className="text-xl">🟢</span>
                  <div className="text-left">
                    <p className="text-sm font-black text-emerald-900 uppercase tracking-tight">Boş Odalar</p>
                    <p className="text-[9px] font-bold text-emerald-400 uppercase tracking-widest">{data.bosOdalar?.length || 0} oda müsait</p>
                  </div>
                </div>
                <span className="text-emerald-400 font-black text-lg">{bosAcik ? '▲' : '▼'}</span>
              </button>

              {bosAcik && (
                <div className="p-4">
                  {(!data.bosOdalar || data.bosOdalar.length === 0) ? (
                    <div className="py-12 text-center">
                      <p className="text-[10px] font-black text-gray-400 uppercase tracking-widest">Boş oda bulunamadı</p>
                    </div>
                  ) : (
                    <div className="grid grid-cols-3 sm:grid-cols-4 gap-3">
                      {data.bosOdalar.map(function(o, i) {
                        return (
                          <div key={i} className="bg-emerald-50 border border-emerald-100 rounded-xl p-3 text-center">
                            <p className="text-base font-black text-emerald-700 leading-none">{o.odaNo}</p>
                            <p className="text-[9px] font-bold text-emerald-400 uppercase tracking-widest mt-1">{o.tur}</p>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
